import React, { useContext } from "react"
import { FirebaseContext } from "./firebase"
import Paper from "@material-ui/core/Paper"
import { Link } from "gatsby"
import Button from "@material-ui/core/Button"
import Avatar from "@material-ui/core/Avatar"
import Alert from "@material-ui/lab/Alert"
import Chip from "@material-ui/core/Chip"

const GameCard = props => {
  const { user } = useContext(FirebaseContext)

  return (
    <Paper
      style={{
        padding: "1em",
        textAlign: "center",
      }}
    >
      <div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 45px 1fr",
          }}
        >
          <div>
            <img
              style={{
                margin: 0,
              }}
              src={`https://firebasestorage.googleapis.com/v0/b/the-final-score-7860d.appspot.com/o/${props.home_team}.svg?alt=media&token=056a31d2-9681-4785-8a66-7b079d5f2119`}
              alt={`${props.home_team}`}
            />
            {!user ? (
              <Chip label={props.away_team} />
            ) : (
              <Chip label={props.data.scores.home.finalScore} />
            )}
          </div>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Avatar
              style={{
                width: "35px",
                height: "35px",
                fontSize: "10pt",
                backgroundColor: "#146633",
              }}
            >
              VS
            </Avatar>
          </span>
          <div>
            <img
              style={{
                margin: 0,
              }}
              src={`https://firebasestorage.googleapis.com/v0/b/the-final-score-7860d.appspot.com/o/${props.away_team}.svg?alt=media&token=056a31d2-9681-4785-8a66-7b079d5f2119`}
              alt={`${props.away_team}`}
            />
            {!user ? (
              <Chip label={props.away_team} />
            ) : (
              <Chip label={props.data.scores.away.finalScore} />
            )}
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          {!user ? (
            <Alert severity="info">
              Please <Link to="/login">login</Link> to view game predictions
            </Alert>
          ) : (
            <Button
              fullWidth
              onClick={() => {
                props.onClick(props)
              }}
            >
              View Details
            </Button>
          )}
        </div>
      </div>
    </Paper>
  )
}

export default GameCard
